import { Reducer, Action } from 'redux';
import { FavouriteAdminListState } from './types-store';
import {
  ACTION, ClearList,
  RequestList, ReceiveList, FailList,
  RequestDeleteFavourite, ReceiveDeleteFavourite, FailDeleteFavourite,
  ClearChangeOwner, UpdateChangeOwnerIsDirty, ChangeOwnerFieldsByKey, ResetChangeOwnerValidation,
  RequestChangeOwner, ReceiveChangeOwner, FailChangeOwner, UpdateChangeOwnerValidation,
  ClearChangeUserGroups, ChangeUserGroupsFieldsByKey, UpdateChangeUserGroupsIsDirty,
  ResetChangeUserGroupsValidation, UpdateChangeUserGroupsValidation, RequestChangeUserGroups,
  ReceiveChangeUserGroups, FailChangeUserGroups, UpdateChangeUserGroupsState, ClearChangeUsers, 
  ChangeUsersFieldsByKey, UpdateChangeUsersIsDirty, UpdateChangeUsersState, ResetChangeUsersValidation, 
  UpdateChangeUsersValidation, RequestChangeUsers, ReceiveChangeUsers, FailChangeUsers
} from './action-types';

export const INITIAL_STATE: FavouriteAdminListState = {
  requestId: 0,
  fetching: false,
  requestedSearchModel: undefined,
  numberOfResults: undefined,
  editableNumberOfResults: undefined,
  listItems: undefined,
  deletingFavourite: [],
  changeOwner: undefined,
  fetchingChangeOwner: undefined,
  changeUserGroups: {
    state: 0
  },
  fetchingChangeUserGroups: undefined,
  changeUsers: {
    state: 0
  },
  fetchingChangeUsers: undefined,
  loadOptions: undefined,
  options: undefined,
  validation: {}
};

const reducers: { [indexer: string]: Reducer<FavouriteAdminListState, Action> } = {

  [ACTION.CLEAR_LIST]: (state: FavouriteAdminListState, action: ClearList): FavouriteAdminListState => {
    return {
      ...state,
      requestId: action.requestId,
      fetching: false,
      requestedSearchModel: undefined,
      numberOfResults: undefined,
      listItems: undefined,
      deletingFavourite: []
    };
  },

  [ACTION.CLEAR_CHANGE_OWNER]: (state: FavouriteAdminListState, action: ClearChangeOwner): FavouriteAdminListState => {

    return {
      ...state,
      changeOwner: undefined
    };
  },

  [ACTION.CHANGE_OWNER_FIELDS_BY_KEY]: (state: FavouriteAdminListState, action: ChangeOwnerFieldsByKey): FavouriteAdminListState => {
    return {
      ...state,
      changeOwner: {
        ...state.changeOwner,
        form: {
          ...state.changeOwner?.form ?? {},
          [action.key]: action.value
        }
      }
    };
  },

  [ACTION.UPDATE_CHANGE_OWNER_IS_DIRTY]: (state: FavouriteAdminListState, action: UpdateChangeOwnerIsDirty): FavouriteAdminListState => {

    return {
      ...state,
      changeOwner: {
        ...state.changeOwner,
        isDirty: action.isDirty
      }
    };
  },

  [ACTION.RESET_CHANGE_OWNER_VALIDATION]: (state: FavouriteAdminListState, action: ResetChangeOwnerValidation): FavouriteAdminListState => {
    const validation = state?.changeOwner?.validation;
    const { [action.key]: undefined, ...updatedValidation } = validation ?? {};

    return state?.changeOwner?.validation ? {
      ...state,
      changeOwner: {
        ...state.changeOwner,
        validation: updatedValidation
      }
    } : state;
  },

  [ACTION.UPDATE_CHANGE_OWNER_VALIDATION]: (state: FavouriteAdminListState,
    action: UpdateChangeOwnerValidation): FavouriteAdminListState => {

    return {
      ...state,
      changeOwner: {
        ...state.changeOwner,
        validation: action.validation
      }
    };
  },

  [ACTION.REQUEST_CHANGE_OWNER]: (state: FavouriteAdminListState, action: RequestChangeOwner): FavouriteAdminListState => {

    return {
      ...state,
      fetchingChangeOwner: true
    };
  },

  [ACTION.RECEIVE_CHANGE_OWNER]: (state: FavouriteAdminListState, action: ReceiveChangeOwner): FavouriteAdminListState => {

    return {
      ...state,
      fetchingChangeOwner: false
    };
  },

  [ACTION.FAIL_CHANGE_OWNER]: (state: FavouriteAdminListState, action: FailChangeOwner): FavouriteAdminListState => {

    return {
      ...state,
      fetchingChangeOwner: false
    };
  },

  [ACTION.CLEAR_CHANGE_USER_GROUPS]: (state: FavouriteAdminListState, action: ClearChangeUserGroups): FavouriteAdminListState => {

    return {
      ...state,
      changeUserGroups: {
        state: 0
      }
    };
  },

  [ACTION.CHANGE_USER_GROUPS_FIELDS_BY_KEY]: (state: FavouriteAdminListState,
    action: ChangeUserGroupsFieldsByKey): FavouriteAdminListState => {
    return {
      ...state,
      changeUserGroups: {
        ...state.changeUserGroups,
        form: {
          ...state.changeUserGroups?.form ?? {},
          [action.key]: action.value
        }
      }
    };
  },

  [ACTION.UPDATE_CHANGE_USER_GROUPS_IS_DIRTY]: (state: FavouriteAdminListState,
    action: UpdateChangeUserGroupsIsDirty): FavouriteAdminListState => {

    return {
      ...state,
      changeUserGroups: {
        ...state.changeUserGroups,
        isDirty: action.isDirty
      }
    };
  },

  [ACTION.UPDATE_CHANGE_USER_GROUPS_STATE]: (state: FavouriteAdminListState,
    action: UpdateChangeUserGroupsState): FavouriteAdminListState => {

    return {
      ...state,
      changeUserGroups: {
        ...state.changeUserGroups,
        state: action.state
      }
    };
  },

  [ACTION.RESET_CHANGE_USER_GROUPS_VALIDATION]: (state: FavouriteAdminListState,
    action: ResetChangeUserGroupsValidation): FavouriteAdminListState => {
    const validation = state?.changeUserGroups?.validation;
    const { [action.key]: undefined, ...updatedValidation } = validation ?? {};

    return state?.changeUserGroups?.validation ? {
      ...state,
      changeUserGroups: {
        ...state.changeUserGroups,
        validation: updatedValidation
      }
    } : state;
  },

  [ACTION.UPDATE_CHANGE_USER_GROUPS_VALIDATION]: (state: FavouriteAdminListState,
    action: UpdateChangeUserGroupsValidation): FavouriteAdminListState => {

    return {
      ...state,
      changeUserGroups: {
        ...state.changeUserGroups,
        validation: action.validation
      }
    };
  },

  [ACTION.REQUEST_CHANGE_USER_GROUPS]: (state: FavouriteAdminListState,
    action: RequestChangeUserGroups): FavouriteAdminListState => {

    return {
      ...state,
      fetchingChangeUserGroups: true
    };
  },

  [ACTION.RECEIVE_CHANGE_USER_GROUPS]: (state: FavouriteAdminListState,
    action: ReceiveChangeUserGroups): FavouriteAdminListState => {

    return {
      ...state,
      fetchingChangeUserGroups: false
    };
  },

  [ACTION.FAIL_CHANGE_USER_GROUPS]: (state: FavouriteAdminListState,
    action: FailChangeUserGroups): FavouriteAdminListState => {

    return {
      ...state,
      fetchingChangeUserGroups: false
    };
  },

  [ACTION.CLEAR_CHANGE_USERS]: (state: FavouriteAdminListState, action: ClearChangeUsers): FavouriteAdminListState => {

    return {
      ...state,
      changeUsers: {
        state: 0
      }
    };
  },

  [ACTION.CHANGE_USERS_FIELDS_BY_KEY]: (state: FavouriteAdminListState,
    action: ChangeUsersFieldsByKey): FavouriteAdminListState => {
    return {
      ...state,
      changeUsers: {
        ...state.changeUsers,
        form: {
          ...state.changeUsers?.form ?? {},
          [action.key]: action.value
        }
      }
    };
  },

  [ACTION.UPDATE_CHANGE_USERS_IS_DIRTY]: (state: FavouriteAdminListState,
    action: UpdateChangeUsersIsDirty): FavouriteAdminListState => {

    return {
      ...state,
      changeUsers: {
        ...state.changeUsers,
        isDirty: action.isDirty
      }
    };
  },

  [ACTION.UPDATE_CHANGE_USERS_STATE]: (state: FavouriteAdminListState,
    action: UpdateChangeUsersState): FavouriteAdminListState => {

    return {
      ...state,
      changeUsers: {
        ...state.changeUsers,
        state: action.state
      }
    };
  },

  [ACTION.RESET_CHANGE_USERS_VALIDATION]: (state: FavouriteAdminListState,
    action: ResetChangeUsersValidation): FavouriteAdminListState => {
    const validation = state?.changeUsers?.validation;
    const { [action.key]: undefined, ...updatedValidation } = validation ?? {};

    return state?.changeUsers?.validation ? {
      ...state,
      changeUsers: {
        ...state.changeUsers,
        validation: updatedValidation
      }
    } : state;
  },

  [ACTION.UPDATE_CHANGE_USERS_VALIDATION]: (state: FavouriteAdminListState,
    action: UpdateChangeUsersValidation): FavouriteAdminListState => {

    return {
      ...state,
      changeUsers: {
        ...state.changeUsers,
        validation: action.validation
      }
    };
  },

  [ACTION.REQUEST_CHANGE_USERS]: (state: FavouriteAdminListState,
    action: RequestChangeUsers): FavouriteAdminListState => {

    return {
      ...state,
      fetchingChangeUsers: true
    };
  },

  [ACTION.RECEIVE_CHANGE_USERS]: (state: FavouriteAdminListState,
    action: ReceiveChangeUsers): FavouriteAdminListState => {

    return {
      ...state,
      fetchingChangeUsers: false
    };
  },

  [ACTION.FAIL_CHANGE_USERS]: (state: FavouriteAdminListState,
    action: FailChangeUsers): FavouriteAdminListState => {

    return {
      ...state,
      fetchingChangeUsers: false
    };
  },

  [ACTION.REQUEST_LIST]: (state: FavouriteAdminListState, action: RequestList): FavouriteAdminListState => {

    return {
      ...state,
      requestId: action.requestId,
      fetching: true,
      requestedSearchModel: action.model,
      ...(action.clearResults && {
        numberOfResults: undefined,
        editableNumberOfResults: undefined,
        listItems: undefined,
        deletingFavourite: []
      })
    };
  },

  [ACTION.RECEIVE_LIST]: (state: FavouriteAdminListState, action: ReceiveList): FavouriteAdminListState => {

    if (action.requestId !== state.requestId) {
      return state;
    }

    return {
      ...state,
      fetching: false,
      numberOfResults: action.numberOfResults,
      editableNumberOfResults: action.editableNumberOfResults,
      listItems: [
        ...(state.listItems || []),
        ...action.list
      ]
    };
  },

  [ACTION.FAIL_LIST]: (state: FavouriteAdminListState, action: FailList): FavouriteAdminListState => {

    if (action.requestId !== state.requestId) {
      return state;
    }

    return {
      ...state,
      fetching: false
    };
  },

  [ACTION.REQUEST_DELETE_FAVOURITE]: (state: FavouriteAdminListState,
    action: RequestDeleteFavourite): FavouriteAdminListState => {

    return !state.deletingFavourite || !state.deletingFavourite.includes(action.id)
      ? {
        ...state,
        deletingFavourite: [
          ...(state.deletingFavourite || []),
          action.id
        ]
      }
      : state;
  },

  [ACTION.RECEIVE_DELETE_FAVOURITE]: (state: FavouriteAdminListState,
    action: ReceiveDeleteFavourite): FavouriteAdminListState => {

    if (!state.deletingFavourite || !state.deletingFavourite.includes(action.id) || !state.listItems?.length) {
      return state;
    }

    const listItems = (state.listItems || []).filter(item => item.code.value !== action.id);

    return {
      ...state,
      listItems,
      numberOfResults: state.numberOfResults - (state.listItems.length - listItems.length),
      deletingFavourite: state.deletingFavourite.filter(id => id !== action.id)
    };
  },

  [ACTION.FAIL_DELETE_FAVOURITE]: (state: FavouriteAdminListState,
    action: FailDeleteFavourite): FavouriteAdminListState => {

    return state.deletingFavourite && state.deletingFavourite.includes(action.id)
      ? {
        ...state,
        deletingFavourite: state.deletingFavourite.filter(id => id !== action.id)
      }
      : state;
  }
};

export const reducer: Reducer<FavouriteAdminListState> = (
  state: FavouriteAdminListState = INITIAL_STATE, action: Action) => {
  const r = reducers[action.type];
  return (r && r(state, action)) || state;
};
